import { render, staticRenderFns } from "./AppScrolldown.vue?vue&type=template&id=120a1a38&scoped=true&"
import script from "./AppScrolldown.vue?vue&type=script&lang=js&"
export * from "./AppScrolldown.vue?vue&type=script&lang=js&"
import style0 from "./AppScrolldown.vue?vue&type=style&index=0&id=120a1a38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120a1a38",
  null
  
)

export default component.exports